export async function getFormularyDrillDown(productId, planIdentity, prescriberId, messageCode, level, messageTypeId) {
    if (!productId || !planIdentity || !prescriberId || !messageCode || !level || !messageTypeId) {
        throw new Error('Missing required parameters');
    }

    const url = `${process.env.REACT_APP_API_URL}FormularyDrillDown/${encodeURIComponent(productId)}/${encodeURIComponent(planIdentity)}?prescriberId=${encodeURIComponent(prescriberId)}&messageCode=${encodeURIComponent(messageCode)}&level=${encodeURIComponent(level)}&messageTypeId=${encodeURIComponent(messageTypeId)}`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(response.statusText || `HTTP ${response.status}`);
    }
}
